import '~/sass/pages/match-car.scss';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
import MatchCarExtent from '@/components/match-car-extent';
import '~/sass/pages/match-car-result.scss';
/* eslint-disable no-alert */

const { $ } = window;

const MEMBER_COUNTER_MIN = 1;
const MEMBER_COUNTER_MAX = 10;

const SLIDER_MIN = 50;
const SLIDER_MAX = 350;
const SLIDER_RANGE = [50, 100, 150, 200, 250, 300, 350];

function initMatch() {
  const MatchCar = new MatchCarExtent();
  console.log(MatchCar.isConstructor);
}

// 取的範圍資料
function getSliderData(SliderMIN, SliderMAX, SliderRange) {
  let arr1 = [];
  arr1 = { range: SliderRange, max: SliderMAX, min: SliderMIN };
  $.ajax({
    url: 'api/match-fson1.ashx',
    type: 'POST',
    dataType: 'json',
    success: (e) => {
      if (e.RS === 'OK') {
        arr1 = { range: e.DATA, max: e.max, min: e.min };
      } else {
        console.log(e.RS);
      }
    },
    error: (e) => {
      console.log(e);
    },
  });
  return arr1;
}

function countMember(currentInput, increase) {
  const currentVal = parseFloat(currentInput.val(), 10);

  if (Number.isNaN(currentVal)) {
    return 1;
  }

  const increased = currentVal + increase;
  if (increased > MEMBER_COUNTER_MAX || increased < MEMBER_COUNTER_MIN) {
    return currentVal;
  }

  return increased;
}

$(document).ready(() => {
  $('[data-match-question]').show();
  $('[data-match-result]').hide();
  const sliderData = getSliderData(SLIDER_MIN, SLIDER_MAX, SLIDER_RANGE);
  console.log(sliderData);
  const slider = document.getElementById('budget-bar');
  noUiSlider.create(slider, {
    start: [sliderData.min, sliderData.max],
    step: 50,
    margin: 50,
    tooltips: false,
    connect: true,
    range: {
      min: sliderData.min,
      max: sliderData.max,
    },
    format: wNumb({
      decimals: 1,
      suffix: '萬',
    }),
    pips: {
      mode: 'values',
      // stepped: true,
      values: sliderData.range,
      density: 0,
      format: wNumb({
        decimals: 0,
        suffix: '萬',
      }),
    },
  });
  /* Member counter */
  const counterInput = $('#member-counter-input');
  $('#member-counter-decrease').on('click', () => {
    counterInput.val(countMember(counterInput, -1));
  });
  $('#member-counter-increase').on('click', () => {
    counterInput.val(countMember(counterInput, 1));
  });

  initMatch();
});
